// The step-away lock PIN's shape and lockout limits (spec/05 §6, spec/07 §4.4; F-SES-12, F-SES-15).
//
// A player sets a 4–6 digit PIN on the first lock; it is stored as a salted hash on the session row
// and verified by the api (never on the station). Five wrong unlock attempts lock unlocking for a
// minute; staff can unlock from the console, which clears the penalty.
//
// These are **plain values only** — no Zod, no `createRoute` — so the eval-free `@clavian/contracts/
// constants` barrel can re-export them for the kiosk lock screen without dragging `@hono/zod-openapi`'s
// `new Function` into a browser bundle (the console `script-src` rule, `constants/index.ts`). The Zod
// schema the routes validate the PIN with is built from `SESSION_PIN_PATTERN` in `routes/sessions.ts`,
// where the OpenAPI Zod already lives.
/** The fewest digits a session PIN may have (spec/07 §4.4). */
export const SESSION_PIN_MIN_LENGTH = 4;
/** The most digits a session PIN may have (spec/07 §4.4). */
export const SESSION_PIN_MAX_LENGTH = 6;
/** A 4–6 digit PIN, digits only. The one source of the rule for the kiosk, the server and the station. */
export const SESSION_PIN_PATTERN = new RegExp(`^\\d{${SESSION_PIN_MIN_LENGTH},${SESSION_PIN_MAX_LENGTH}}$`);
/** Is `value` a well-formed session PIN — 4–6 digits, nothing else? */
export function isSessionPinShape(value) {
    return SESSION_PIN_PATTERN.test(value);
}
/** Wrong unlock attempts in a row before unlocking is locked (spec/05 §6 rule 5). */
export const SESSION_UNLOCK_MAX_ATTEMPTS = 5;
/** How long unlocking is locked after `SESSION_UNLOCK_MAX_ATTEMPTS` wrong PINs, in seconds (spec/05 §6 rule 5). */
export const SESSION_UNLOCK_PENALTY_SECONDS = 60;
/** How a player proves themselves to unlock a locked session (spec/05 §6, spec/12 §11). */
export const SESSION_UNLOCK_METHODS = ['pin', 'password', 'phone'];
//# sourceMappingURL=session-pin.js.map